/**
 * @module app
 *
 * This is the javascript bundle entry file.
 * Its purpose is to import and initialize all other javascript
 * modules in the bundle.
 */

import addEnvClasses from "./env-capabilities";
import initMobileMenu from "./mobile-menu";
import initStickyNav from "./sticky-nav";
import initIntegrations from "./integrations";
import openChatboxOnCountdown from "./automated-feature";
import initOlarkApiCalls from "./olark-api";
import createAffiliate from "./ambassador";
import initCTATracking from "./cta-tracking";
import initReferrers from "./rid";
import initAnnouncements from "./announcement-banner";
import initSignupFunctionality from "./signup";

// Add environment classes
addEnvClasses();

// Set up event handling on the mobile menu
initMobileMenu();

// Initialize any site announcements we may have
initAnnouncements();

// Set up event handling for the integrations page filter
initIntegrations();

// Capture customer information through the chatbox
initOlarkApiCalls();

// Set ambassador-related cookies
createAffiliate();

// Tell Segment to track clicks on CTAs
initCTATracking();

// Set up referrer tracking
initReferrers();

// Set up sticky navigation
initStickyNav();

// Set up signup handlers (e.g. for NoCC handling and signup form validation)
initSignupFunctionality();

// Launch page-specific code
import "./views/home";
import "./views/pricing.js";
import "./views/partner-thanks";
import "./views/integrations-single";
import "./views/affiliates";
import "./views/help-article.js";
import "./views/api.js";
import "./views/landing-pages.js";
import "./views/interactive-tour.js";
import "./views/global-accessibility-awareness-day.js";
import "./views/onboarding.js";
import "./views/live-chat-powered-by-olark.js";
import "./views/nav.js";

import "./views/chatbot-copilot.js";
import "./views/meet.js";
